
import Vue from 'vue'
import Component from 'vue-class-component'
import { namespace } from 'vuex-class'
import CheckoutCondicoesContainer from '../components/checkout/CheckoutCondicoesContainer.vue'
import ProdutosContainer from '../components/checkout/ProdutosContainer.vue'
import TrocasContainer from '../components/checkout/TrocasContainer.vue'

const AppConfigStore = namespace('AppConfig')
const pedidoStore = namespace('Pedido')

@Component({
  name: 'CheckoutView',
  components: {
    ProdutosContainer,
    TrocasContainer,
    CheckoutCondicoesContainer
  }
})
export default class CheckoutView extends Vue {
  tab = 'one'

  @AppConfigStore.Getter
  getConfigTrocas!: any

  @pedidoStore.State
  trocas!: any[];

  get quantidadeTrocas(): number {
    return this.trocas?.reduce((acc, curr) => acc + curr.quantidade, 0) || 0
  }
}
